import { render, staticRenderFns } from "./Pomoc.vue?vue&type=template&id=77d5cbd9&"
import script from "./Pomoc.vue?vue&type=script&lang=js&"
export * from "./Pomoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports